// extracted by mini-css-extract-plugin
export var cardIcon = "_98-4";
export var checkboxCard = "_98-0";
export var checkboxCardSelected = "_98-3";
export var disabled = "_98-1";
export var outerBorder = "_98-2";
export var spacerMedium = "_98-7";
export var spacerSmall = "_98-6";
export var spacerXsmall = "_98-5";